import React from "react";
import Header2 from "../../layout/Header2";
import LookupTable from "./LookupTable";
import Footer from "../../layout/Footer";

export const PER_PAGE = 10;

const VoterIdLookup = () => {
  return (
    <>
      <Header2 />

      <div className="w-full flex flex-col justify-center items-center xl:mt-[162px] lg:mt-[140px] mt-[100px] font-mont lg-xl:mb-20 lg:mb-15 mb-10">
        <div className="bg-[#A00028] h-[120px] md:h-[160px] flex items-center justify-center w-full">
          <div className="text-white font-mont text-center">
            <h1 className="text-3xl md:text-4xl font-semibold mb-2 font-fira">ADD A VOTER</h1>
            {/* <p className="text-sm md:text-base">Last Updated on 13/06/25</p> */}
          </div>
          </div>
        <div
          id="voter-id-lookup"
          className="w-full max-w-[1440px] px-[20px] flex flex-col gap-8"
        >
          <div className="self-start mt-10 text-center flex justify-center w-full">
            <ul className="list-disc list-inside space-y-2 text-base font-semibold text-left md:text-lg">
              <li>
                Start SEARCH – Enter the legal first and last name of your
                contact (Add yourself first to this list)
              </li>
              <li>
                You are accessing the HARRIS COUNTY registered voter database
              </li>
              <li>ONLY Harris County registered voters' data is available</li>
            </ul>
          </div>

          <LookupTable />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default VoterIdLookup;
